module.exports = __webpack_public_path__ + "img/roast.fbd4dff6.svg";